var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { VideoWrapper } from './wrappers/VideoWrapper';
import { ensureCachedVideoElement } from './ensureCachedVideoElement';
import { shouldUseIvsWrapper } from './helpers';
export const previousWrapper = {};
const getWrapperClass = (video) => __awaiter(void 0, void 0, void 0, function* () {
    if (shouldUseIvsWrapper(video)) {
        const { isIVSSupported, IVSWrapper } = yield import('./wrappers/IVSWrapper');
        if (isIVSSupported()) {
            return IVSWrapper;
        }
    }
    return VideoWrapper;
});
export const discardWrapper = (key) => {
    var _a;
    (_a = previousWrapper[key]) === null || _a === void 0 ? void 0 : _a.reset(key);
    delete previousWrapper[key];
};
export function videoWrapperFactory(video, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { key } = options;
        const WrapperClass = yield getWrapperClass(video);
        if (previousWrapper[key] instanceof WrapperClass &&
            ((_a = previousWrapper[key]) === null || _a === void 0 ? void 0 : _a.shouldReuse(video))) {
            return previousWrapper[key];
        }
        (_b = previousWrapper[key]) === null || _b === void 0 ? void 0 : _b.reset(key, video);
        const wrapper = new WrapperClass(video, ensureCachedVideoElement(options));
        previousWrapper[key] = wrapper;
        return wrapper;
    });
}
